// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.7.1_@swc+helpers@0.5.23__webpack@5.98.0_@swc+core@1.15._207d30a1a39a4eca1cd7ece3f0ffaa06/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.7.1_@swc+helpers@0.5.23__webpack@5.98.0_@swc+core@1.15._207d30a1a39a4eca1cd7ece3f0ffaa06/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
#    Colors
   ========================================================================== */
/*\$mainColor:#d40621;
\$alphaLight:rgba(#fff, .5);
\$alphaDark:rgba(#000, .5);
\$placeholderTextLight:rgba(#fff, .7);
\$placeholderTextDark:rgba(#000, .7);

\$textLight: #fff;
\$textDark: #404040;
\$textThemes:#d40621;*/
/* ################## */
/* ################## */
/* ################## */
/* ################## */
breadcrumbs .content, breadcrumbs .goBack {
  display: flex;
  align-items: center;
  flex-direction: row;
  height: 60px;
  box-sizing: border-box;
  padding: 20px;
  color: var(--c_mainColorDark);
  -webkit-user-select: none;
          user-select: none;
  border-radius: 4px;
  background-color: var(--c_backgroundBox);
}

breadcrumbs {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  font-size: 1rem;
  line-height: normal;
}
breadcrumbs .goBack {
  margin-right: var(--m_relatedContents);
  cursor: pointer;
}
breadcrumbs .goBack .svg_arrowLeft {
  width: 20px;
  margin-right: 10px;
}
breadcrumbs .content {
  justify-content: space-between;
  flex-grow: 1;
}
breadcrumbs .breadList {
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
}
breadcrumbs .breadList .clickable a {
  cursor: pointer;
}
breadcrumbs .breadList .selected span,
breadcrumbs .breadList .selected a {
  cursor: default;
}
breadcrumbs .breadList .selected span::before,
breadcrumbs .breadList .selected a::before {
  content: "";
  position: absolute;
  bottom: -1px;
  height: 1px;
  width: 100%;
  background: var(--c_mainColorDark);
}
breadcrumbs .breadList__item {
  position: relative;
  display: flex;
  color: var(--c_mainColorDark);
}
breadcrumbs .breadList__item .svg_arrowRight {
  width: 16px;
  margin: 0 var(--m_components)-3;
}
breadcrumbs .breadList__item .svg_arrowRight .fill {
  fill: var(--c_mainColorDark);
}
breadcrumbs .breadList__item a {
  cursor: default;
  color: var(--c_mainColorDark);
}
breadcrumbs .breadList .disabled span,
breadcrumbs .breadList .disabled a {
  color: rgba(var(--c_textBody), 0.54285714);
}
breadcrumbs .breadList .disabled span::before,
breadcrumbs .breadList .disabled a::before {
  color: rgba(var(--c_textBody), 0.54285714);
}
breadcrumbs .breadList .disabled .svg_arrowRight {
  width: 16px;
  margin: 0 var(--m_components)-3;
}
breadcrumbs .breadList .disabled .svg_arrowRight .fill {
  fill: rgba(var(--c_textBody), 0.54285714);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
